import { render } from "./BDLayout.vue?vue&type=template&id=8c3fba10&scoped=true"
import script from "./BDLayout.vue?vue&type=script&lang=js"
export * from "./BDLayout.vue?vue&type=script&lang=js"

import "./BDLayout.vue?vue&type=style&index=0&id=8c3fba10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3fba10"]])

export default __exports__